<template>
    <div class="cancellation-section">
        <div class="nav-bar">
            <div class="bar-item" @click="onExit">アカウントについて</div>
            <div class="bar-item active">アカウントを削除したいです</div>
        </div>
        <div class="reason-section">
            <ReasonList
                :user-info="userInfo"
                v-on:toggle-can-submit="(canSubmit) => (submitBtnDisabled = !canSubmit)"
                ref="reason"
            ></ReasonList>

            <div class="btn-section">
                <div v-if="toastInfo.toastLeftTime > 0" class="toast">
                    {{ toastInfo.content }}
                </div>
                <Button @click="submit" :class="['custom-btn', submitBtnDisabled && 'cant-click']">
                    提出
                </Button>
            </div>
        </div>

        <Dialog :visible.sync="showSuccessPop" class="success-dialog" :before-close="onExit">
            <div class="error-tip-section result-success-section">
                <div class="sorry-icon success-icon"></div>
                <div class="dialog-title">アカウントの削除申請を提出しました</div>
                <div class="error-msg success-msg">
                    アカウントの削除申請を提出しました！アカウントは7日後に削除されます。 <br />
                    申請から7日以内であればPokekaraのアカウントを復元することができます。運営からのお知らせで「削除申請を取り消す」を選択してください。
                </div>
                <Button @click="onExit" class="custom-btn go-home-btn"> 了解 </Button>
            </div>
        </Dialog>

        <Dialog :visible.sync="showFailPop" class="fail-dialog" :before-close="onExit">
            <div class="error-tip-section">
                <div class="sorry-icon"></div>
                <div class="dialog-title">異常を検出</div>
                <div class="error-msg">{{ errorMsg }}</div>
                <Button @click="onExit" class="custom-btn go-home-btn"> 了解 </Button>
            </div>
        </Dialog>
    </div>
</template>

<script>
import { Button } from './ElComponents';
import { Dialog } from 'element-ui';
import 'element-ui/lib/theme-chalk/dialog.css';

import ReasonList from './cancellation/ReasonList';
import { request } from '../../common/module/request';
import { util } from '../../common/module/util';
import { Tracker } from '../../common/module/Tracker';
import { track } from '../../common/module/TrackerWrapper';
import { BOM } from '../../common/module/BOM';
const { getEnv } = util;

// 提示倒计时
let toastTimer;

export default {
    name: 'Cancellation',
    data: () => {
        return {
            env: getEnv(),
            // 当前展示内容： 0-表单，1-注销理由，2-错误提示，3-注销成功提示
            errorMsg: '',
            showFailPop: false,

            showSuccessPop: false,

            // 提交按钮禁用
            submitBtnDisabled: true,
            // toast提示
            toastInfo: {
                toastLeftTime: 0,
                content: ''
            },
            userInfo: {},
            rules: {
                uid: [{ trigger: 'change' }]
            }
        };
    },
    props: ['onExit', 'userInfo'],
    components: {
        Button,
        ReasonList,
        Dialog
    },
    methods: {
        // 返回帮助中心
        goHelpCenter() {
            const self = this;
            let url = '';
            if (self.env === 'dev') {
                url = `${window.location.origin}/static/dev/cli/helpCenter/dist/index.html`;
            } else {
                url =
                    'https://www.pokekara.com/static/online/cli/helpCenter/dist/cancellation.html';
            }
            window.location.href = url;
        },

        // 检验用户id
        verifyUser() {
            const self = this;
            request({
                url: '/x/user/simple_info',
                data: {
                    display_id: self.userInfo.display_id,
                    platform: 4
                },
                callback: function(data) {
                    if (data.err_code === 0 && data.data.user && data.data.user.uid) {
                        if (data.data.apply_deletion) {
                            self.showFailPop = true;
                            self.errorMsg = 'すでにアカウントの削除申請を提出しています！ただ今処理中です。しばらくお待ちください。';
                        }
                    } else {
                        self.uidVerifyStatus = 3;
                        self.userInfo = {};
                        // alert(data.err_msg);
                    }
                },
                error: function(status, e) {
                    alert(e);
                }
            });
        },

        // 提交
        submit() {
            const self = this;
            if (self.submitBtnDisabled) {
                self.toastInfo.toastLeftTime = 5;
                self.toastInfo.content = '削除したい理由を選んでください！';
                toastTimer = setInterval(() => {
                    self.toastInfo.toastLeftTime--;
                    if (self.toastInfo.toastLeftTime === 0) {
                        if (toastTimer) {
                            clearInterval(toastTimer);
                        }
                    }
                }, 1000);
                return;
            }
            const { reasonList } = self.$refs.reason;
            const reasonArray = [];
            reasonList.forEach(item => {
                if (item.checked) {
                    if (typeof item.customReason === 'string') {
                        reasonArray.push(item.customReason.trim());
                    } else {
                        reasonArray.push(item.des);
                    }
                }
            });
            const reason = reasonArray.join(',');
            request({
                url: '/x/user/application/submit',
                method: 'post',
                json: true,
                data: {
                    reason
                },
                callback:(data)=>{
                    if (data.err_code === 0 && data.data) {
                        self.showSuccessPop = true;
                        //success
                        this.Tracker.track("click_delete_success");
                        track('poke_web_FAQ', 'click_FAQ_account_logOff_success');
                    }
                },
                error: function(e) {
                    alert(e);
                }
            });
        }
    },
    mounted() {
        this.verifyUser();
        //统计
        this.Tracker=new Tracker("delete_pc","click_delete");
    }
};
</script>

<style lang="scss" rel="stylesheet/scss">
@import '../../common/sass/basic/mixin';

.cancellation-section {
    .nav-bar {
        @include flexpipe();
        @include alignitem(center);
        font-size: 14px;
        line-height: 20px;
        color: rgb(125, 125, 125);
        margin: 28px 0 0;

        .bar-item {
            @include flexpipe();
            @include alignitem(center);
            cursor: pointer;
        }

        .active {
            color: #1391ee;
        }

        .bar-item + .bar-item {
            &:before {
                content: '>';
                display: block;
                margin: 0 13px;
                color: rgb(125, 125, 125);
            }
        }
    }

    .reason-section {
        padding-bottom: 20px;
        .btn-section {
            margin-top: 54px;
            text-align: center;
            position: relative;

            .custom-btn {
                width: 230px;
                height: 54px;
                line-height: 54px;
                padding: 0;
            }

            .cant-click {
                background: #c5c5c5;
                color: #fff;
                border-color: #c5c5c5;
                cursor: no-drop;
            }

            .toast {
                margin: 0 auto;
                position: absolute;
                top: -58px;
                left: 0;
                right: 0;
            }
        }
    }

    .fail-dialog {
        .el-dialog {
            width: 500px;
            padding: 0;

            .el-dialog__body {
                padding: 0;
                height: 344px;
                overflow: hidden;
            }
        }
    }

    .error-tip-section {
        text-align: center;

        .sorry-icon {
            background: center/100% 100% no-repeat
                url('../assets/cancellation/icon-error-sorry.png');
            width: 124px;
            height: 116px;
            margin: 30px auto 0;
        }

        .dialog-title {
            margin-top: 21px;
            line-height: 18px;
            font-weight: bold;
            font-size: 18px;
            color: #000;
        }

        .error-msg {
            font-size: 12px;
            color: rgb(146, 146, 146);
            line-height: 17px;
            margin: 12px auto 0;
            width: 390px;
        }

        .go-home-btn {
            margin-top: 30px;
            width: 420px;
        }
    }

    .success-dialog {
    }

    .result-success-section {
        .success-icon {
            background: center/100% 100% no-repeat
                url('../assets/cancellation/icon-result-success.png');
            width: 156px;
            height: 103px;
        }

        .success-msg {
            width: 420px;
        }
    }

    .toast {
        margin-top: 50px;
        font-size: 14px;
        color: rgb(138, 138, 138);
        position: relative;
        @include flexpipe();
        @include alignitem(center);
        @include justify-content(center);

        &:before {
            content: '';
            display: block;
            width: 23px;
            height: 23px;
            margin-right: 10px;
            background: center/100% 100% no-repeat url('../assets/cancellation/icon-form-error.png');
        }
    }
}
</style>
